export const caseInsensitiveEquals = (
    target: string,
    toMatch: Nullable<string>,
): boolean =>
    !!toMatch &&
    target.localeCompare(toMatch, undefined, { sensitivity: 'base' }) === 0;

export const matchServiceByKey = <T extends { serviceKey?: Nullable<string> }>(
    targetKey: string,
) => ({ serviceKey }: T) => caseInsensitiveEquals(targetKey, serviceKey);
